import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        height: "64px",
        bgcolor: "#FFF",
        px: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="body2">
        © {currentYear} All rights reserved
      </Typography>

      <Stack direction="row" alignItems="center">
        {["Terms of Use", "Privacy Policy", "About Optum"].map((label, i, arr) => (
          <Link
            key={label}
            href="#"
            underline="always"
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: 0,
              textDecorationStyle: "solid",
              color: "#3D3C38 !important",
              px: 1.5,
              borderRight: i < arr.length - 1 ? "1px solid #B1B2B4" : "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            {label}
          </Link>
        ))}
      </Stack>
    </Box>
  );
};

export default Footer;
